import { distinctUntilChanged, map, skip, tap, withLatestFrom } from 'rxjs';
import { dispatchAction } from '@ardoq/rxbeach';
import { isEqual } from '@ardoq/common-helpers';
import { getSelectComponentHierarchySelection$ } from '../../streams/selectComponentHierarchySelection$';
import { selectComponentSelectionChanged } from '../../actions';
import { GetAdditionalRoutineArgs } from '../../types';

export const getSelectComponentSelectionChangedRoutine = ({
  navigatorConfiguration,
  navigator$,
}: GetAdditionalRoutineArgs) =>
  getSelectComponentHierarchySelection$(
    navigatorConfiguration.actionNamespace
  ).pipe(
    // The selectComponentHierarchySelection$ stream emits initial state on
    // subscription which is not an actual user triggered change of the
    // selection.
    skip(1),
    map(({ treeSelection }) => treeSelection),
    distinctUntilChanged(isEqual),
    withLatestFrom(navigator$),
    tap(([selection, tree]) => {
      const scopeData =
        tree.navigatorViewInterface.getScopeDataForComponentIds(selection);
      dispatchAction(
        selectComponentSelectionChanged(scopeData),
        navigatorConfiguration.actionNamespace
      );
    })
  );
